<template>
	<v-btn
		color="dangerous white--text"
		@click="clickAction"
		:style="{ fontWeight: textFontWeight }"
		block
		tile
		:disabled="Boolean(isDisabled) || isProcessing"
		>{{ buttonTitle }}</v-btn
	>
</template>

<script>
export default {
	name: 'ActiveDangerousButton',
	data: () => ({
		textFontWeight: 'bold',
		isProcessing: false
	}),
	props: ['buttonTitle', 'isDisabled'],
	methods: {
		async clickAction(event) {
			if (this.isProcessing) return
			this.isProcessing = true
			try {
				await this.$emit('clickAction', event)
			} finally {
				this.isProcessing = false
			}
		}
	}
}
</script>

<style lang="scss" scoped></style>
